import * as React from 'react';
import { Clickable } from '@mentimeter/ragnar-ui/clickable';
import { trackUser } from '@api/tracking/client';
import { usePresentationContext } from '../../../legacy-context/presentationContext';
import type { VideoState } from '../utils';

export const OpenVideoOverlayTrigger = () => {
  const { useSlideState } = usePresentationContext();
  const [, setSlideState] = useSlideState<VideoState>();

  return (
    <Clickable
      data-testid="video-player"
      position="absolute"
      width="100%"
      height="100%"
      zIndex={1}
      onClick={() => {
        setSlideState({ videoState: 'loading' });
        trackUser({
          event: 'Played video',
          properties: { placement: 'Thumbnail', type: 'video' },
        });
      }}
    />
  );
};
